import type { FaireProductEntity } from "../../entity_types/product";

export const p_5qfpxpcp7m: FaireProductEntity = {
  token: "p_5qfpxpcp7m",
  type: "product",
  name: "Desert Landscape Jigsaw Puzzle – Premium 1000-Piece Adult",
  brandToken: "b_8r78hbsnh2",
  brandName: "Snappy Puzzles",
  imageUrl:
    "https://cdn.faire.com/fastly/2469005d7d2ce4e1a3c5aa1ec15fa32cde73542ebb4c47bad7b9f883e1ebb215.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5574c95d6c44f693269e462093ba94681c67186085d56d26ea0f0dfe23412928.png",
    "https://cdn.faire.com/fastly/300da39759ce8940c332e15159c222557165c27af6175b162f1d651b2d694766.jpeg",
    "https://cdn.faire.com/fastly/199c7d648abf984b9bd601e46db5a3fe1930d1c00f3604d2958daaee7f683b65.png",
    "https://cdn.faire.com/fastly/91a5c1a28d6581f33725e3b283c6c02cd69becc1a8d742bc0e15d4833af87077.png",
    "https://cdn.faire.com/fastly/f5448d01eff20a1e29d5c395cd71943901690609bb903f9ef783252b0e2a1708.png",
    "https://cdn.faire.com/fastly/1043767405d14154aed4c806919b855d1536aeb5ffd39a3d2979af662f1ff893.png",
    "https://cdn.faire.com/fastly/917b6e2c8677c828463f77e9750a92475e50e5763c86d8210f7ad77c526b4b36.png",
  ],
  priceDollars: 24.5,
  description:
    "Title: Under Desert Skies\n\nA premium 1000-piece adult jigsaw puzzle featuring a serene desert landscape featuring a camper van beneath starry skies, blending travel, nature, and adventure themes. Designed to stand out on shelves and sell easily as a gift, with modern artwork customers instantly understand.\n\n⸻\n\nWhy Retailers Love It\n\t•\tEasy-to-sell adult jigsaw puzzle with broad gift appeal\n\t•\tMade in the USA with premium recycled chipboard\n\t•\tSmooth, low-glare satin finish\n\t•\tRibbon-cut pieces for a satisfying, consistent fit\n\t•\tClean, modern artwork that displays well in retail settings\n\n⸻\n\nProduct Details\n\t•\t1000 precision-cut jigsaw pieces\n\t•\tFinished puzzle size: 26.6 × 19.25 inches\n\t•\tPremium recycled chipboard construction\n\t•\tSatin finish for reduced glare\n\t•\tRibbon-cut pieces for reliable piece fit\n\t•\tDesigned and printed in the USA\n\n⸻\n\nIdeal For\n\t•\tGift shops & bookstores\n\t•\tMuseum & lifestyle shops\n\t•\tHoliday and everyday gifting\n\t•\tCustomers seeking relaxing, screen-free activities\n\n⸻\n\nBrand Values\n\nSnappy Puzzles operates a Buy 5, Give 1 program as part of our commitment to screen-free connection. Donations are funded and managed by our brand and are not passed on to retail partners.",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:11.400Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
